import Vue from 'vue'

import {backendBase, apiBase, siteBase} from "../config.json";
global.BACKEND_BASE  = backendBase;
global.API_BASE  = apiBase;
global.SITE_BASE = siteBase;

window._ = require('lodash');
// window.moment = require('moment');
window.moment = require('moment-timezone');
window.swal = require('sweetalert');
window.jQuery = require( "jquery" );

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, {locale});

import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)

// Viser
import Viser from 'viser-vue';
Vue.use(Viser);

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';

import "@/design/index.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts);

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.component('date-picker', datePicker);

// Vue Select
import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

// Loading
Vue.component('loading-screen', require('./components/LoadingScreen').default);
Vue.component('errors', require('./components/Errors').default);
Vue.component('pagination', require('laravel-vue-pagination'));

// Laravel Echo
import Echo from 'laravel-echo';
import {pusherAppKey, pusherCluster} from "../pusher_config.json";
window.Pusher = require('pusher-js');
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: pusherAppKey,
  cluster: pusherCluster,
  forceTLS: true,
  authEndpoint: BACKEND_BASE + '/broadcasting/auth'
});

let savedTimezone = localStorage.getItem('itgTimezone');
if (savedTimezone) {
 window.itgTimezone = savedTimezone;
} else {
  window.itgTimezone = window.moment.tz.guess();
}

let shouldLoadIncompleteTasks = localStorage.getItem('itgShouldLoadIncompleteTasks');
if (shouldLoadIncompleteTasks !== null) {
  window.itgShouldLoadIncompleteTasks = shouldLoadIncompleteTasks;
} else {
  window.itgShouldLoadIncompleteTasks = false;
}

let highlightTicketsWithNoCommunicationSince = localStorage.getItem('itgHighlightTicketsWithNoCommunicationSince');
if (highlightTicketsWithNoCommunicationSince) {
  window.itgHighlightTicketsWithNoCommunicationSince = highlightTicketsWithNoCommunicationSince;
} else {
  window.itgHighlightTicketsWithNoCommunicationSince = null;
}

let openTicketInSameWindow = localStorage.getItem('itgOpenTicketInSameWindow');
// if null, set to true
if (openTicketInSameWindow === null) {
  openTicketInSameWindow = true;
}
if (openTicketInSameWindow == 'true') {
  openTicketInSameWindow = true;
}
if (openTicketInSameWindow == 'false') {
  openTicketInSameWindow = false;
}

if (openTicketInSameWindow) {
  window.itgOpenTicketInSameWindow = openTicketInSameWindow;
} else {
  window.itgOpenTicketInSameWindow = false;
  // window.itgOpenTicketInSameWindow = true;
}

// Auth 0
// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";
// Import the plugin here
import { ActiveDirectoryPlugin } from "./auth";
// Install the authentication plugin here
Vue.use(ActiveDirectoryPlugin, router, {});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
